import httpRequest from "../../../axios/index";
import { ADMIN_CUSTOMER, ADMIN_DRIVERS } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";

const GetAllCustomer = async (
  setLoading,
  SetAllData,
  type = "",
  Search = "",
  Date = "",
  AcountType = "",
  page = 1
) => {
  try {
    setLoading(true);
    let params = new URLSearchParams();

    if (type && type !== "All") {
      params.append("type", type.toLowerCase());
    }
    if (Search) {
      params.append("search", Search);
    }
    if (Date) {
      params.append("date", Date);
    }
    if (AcountType) {
      params.append("account_type", AcountType);
    }
    if (page) {
      params.append("page", page);
    }
    let url = `${ADMIN_CUSTOMER}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const resp = await httpRequest.get(url);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

// get the customer details data

const GetCustomerByID = async (setLoading, SetAllData, ID = "", page) => {
  try {
    setLoading(true);
    let params = new URLSearchParams();
    if (page) {
      params.append("page", page);
    }
    let url = `${ADMIN_CUSTOMER}`;
    if (params.toString()) {
      url += `/${ID}?${params.toString()}`;
    }
    const resp = await httpRequest.get(`${url}`);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

// update the customer status
const UpdateCustomerStatus = async (
  setLoading,
  ID = "",
  status = "",
  apiType = ""
) => {
  try {
    setLoading(true);
    let url;
    if (apiType === "customers") {
      url = ADMIN_CUSTOMER;
    } else if (apiType === "drivers") {
      url = ADMIN_DRIVERS;
    }
    const resp = await httpRequest.patch(`${url}/${ID}`, { status });
    return resp;
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

export { GetAllCustomer, GetCustomerByID, UpdateCustomerStatus };
